var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
export var Emoji = function (props) { return (React.createElement(Span, { className: "emoji", role: "img", size: props.size || 20, "aria-label": props.label ? props.label : '', "aria-hidden": props.label ? 'false' : 'true' }, props.symbol)); };
var Span = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n"], ["\n  font-size: ", "px;\n"])), function (props) { return props.size; });
var templateObject_1;
